import React from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImages,
  faWandMagicSparkles,
  faCrown,
  faSliders,
} from "@fortawesome/free-solid-svg-icons";
import { PanelWembii } from "../PanelWembii";
import { MediaSourceId } from "../../../cores/videoGen/types";
import cn from "classnames";

const SOURCES: {
  id: MediaSourceId;
  icon: typeof faImages;
  labelId: string;
  tag?: string;
}[] = [
  { id: "stock", icon: faImages, labelId: "app.videoGen.media.stock" },
  { id: "aiImage", icon: faWandMagicSparkles, labelId: "app.videoGen.media.aiImage" },
  { id: "istock", icon: faCrown, labelId: "app.videoGen.media.istock", tag: "Negocios" },
  { id: "custom", icon: faSliders, labelId: "app.videoGen.media.custom" },
];

interface MediaSourceCardsProps {
  value: MediaSourceId;
  onChange: (id: MediaSourceId) => void;
}

export function MediaSourceCards({ value, onChange }: MediaSourceCardsProps) {
  const intl = useIntl();

  return (
    <div className="video-gen-media">
      <div className="video-gen-media__grid">
        {SOURCES.map(({ id, icon, labelId, tag }) => (
          <PanelWembii
            key={id}
            shadow
            className={cn(
              "video-gen-media__card pointer border",
              { "video-gen-media__card--active": value === id }
            )}
            onClick={() => onChange(id)}
          >
            <div className="video-gen-media__card-icon">
              <FontAwesomeIcon icon={icon} />
            </div>
            {tag && <span className="video-gen-media__card-tag">{tag}</span>}
            <span className="video-gen-media__card-label">
              {intl.formatMessage({ id: labelId })}
            </span>
          </PanelWembii>
        ))}
      </div>
    </div>
  );
}
